<template>
  <div>
    <settings-card
      v-loading="loading"
      :config="config">
      <el-button
        type="text"
        @click="apply">去设置</el-button>
    </settings-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
export default {
  name: 'ActivityCard',
  components: {
    SettingsCard
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    apply() {
      this.$router.push(this.config.url)
    }
  }
}
</script>
